const state = {
  structures: [],
  showStructures: true,
}

const getters = {
  getStructures: (state) => {
    return state.structures
  },
  getCheckedStructures: (state) => {
    return state.structures.filter((e) => e.checked).map((e) => (e.chemical ? e.chemical : e))
  },
  isViewStructures: (state) => {
    return state.showStructures
  },
}

const mutations = {
  ADD_STRUCTURES: (state, payload) => {
    state.structures.push(...payload)
  },
  ADD_STRUCTURE: (state, payload) => {
    state.structures.push(payload)
  },
  DELETE_STRUCTURES: (state, payload) => {
    state.structures = state.structures.filter((obj) => !payload.includes(obj))
  },
  CLEAR_STRUCTURES: (state) => {
    state.structures = []
  },
  UPDATE_STRUCTURE: (state, payload) => {
    const updateObj = state.structures.find((e) => (e.chemId || e.chemical.chemId) === payload.chemId)

    if (updateObj) updateObj.checked = !updateObj.checked

    state.structures = state.structures.filter(() => true)
  },
  SELECT_ALL_STRUCTURES: (state) => {
    state.structures.forEach((e) => (e.checked = true))

    state.structures = state.structures.filter(() => true)
  },
  DESELECT_ALL_STRUCTURES: (state) => {
    state.structures.forEach((e) => (e.checked = false))

    state.structures = state.structures.filter(() => true)
  },
  DESELECT_SOME_STRUCTURES: (state, payload) => {
    const payloadSmiles = payload.map((obj) => obj.smiles)
    state.structures.filter((obj) => payloadSmiles.includes(obj.chemical.smiles)).forEach((e) => (e.checked = false))
    state.structures = state.structures.filter(() => true)
  },
  SET_VIEW_STRUCTURES: (state, payload) => {
    state.showStructures = payload
  },
}

const actions = {
  addUniqueStructures: (context, payload) => {
    const newStructures = payload.filter(
      (s) =>
        !context.state.structures.some((os) => {
          let b = (os.chemId || os.chemical.chemId) === (s.chemId || s.chemical.chemId)
          return b
        }),
    )
    newStructures.forEach((s) => (s.checked = true))
    context.commit('ADD_STRUCTURES', newStructures)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
